export default __webpack_public_path__ + "static/media/ordLeftTriangle.26dfc83c.svg";